/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Utils\Tabs.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday October 8th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday October 8th 2024 2:17:16 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Box } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  idlabel: string;
  aria: string;
};

export function a11yProps(index: number, label: string) {
  return {
    id: `${label}-tab-${index}`,
    'aria-controls': `${label}-tabpanel-${index}`,
  };
};

export function CustomTabPanel(props: TabPanelProps) {
  return (
    <div role="tabpanel"
      hidden={props.value !== props.index}
      id={`${props.idlabel}-${props.index}`}
      aria-labelledby={`${props.aria}-${props.index}`}>
      {props.value === props.index && (
        <Box sx={{ p: 3 }}>
          {props.children}
        </Box>
      )}
    </div>
  );
};
